import { render, staticRenderFns } from "./AnswerUpdatetext.vue?vue&type=template&id=e535c622&scoped=true"
import script from "./AnswerUpdatetext.vue?vue&type=script&lang=js"
export * from "./AnswerUpdatetext.vue?vue&type=script&lang=js"
import style0 from "./AnswerUpdatetext.vue?vue&type=style&index=0&id=e535c622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e535c622",
  null
  
)

export default component.exports